import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ExitImpersonationModalComponent } from '@app/easylot-admin/modules/impersonation/exit-impersonation-modal/exit-impersonation-modal.component';
import { ImpersonationService } from '@app/easylot-admin/modules/impersonation/services/impersonation.service';
import { ImpersonationActions } from '@app/easylot-admin/modules/impersonation/store/impersonation.slice';
import { UserService } from '@authentication/services/user.service';
import { DialogService } from '@shared/services/dialog.service';

@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
  constructor(
    private userService: UserService,
    private dialogService: DialogService,
    private impersonationService: ImpersonationService,
    private store: Store
  ) {}
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      !this.impersonationService.impersonationAlertShown.value &&
      !request.url.includes('me/impersonation-context') &&
      this.userService.currentUser.value?.impersonationTTL
    ) {
      if (
        this.userService.currentUser.value.impersonationTTL.getTime() -
          new Date().getTime() <
        30000
      ) {
        this.impersonationService.impersonationAlertShown.next(true);
        this.dialogService
          .openDialog(ExitImpersonationModalComponent, {
            maxWidth: 500,
            minHeight: 'unset',
          })
          .afterClosed()
          .subscribe((confirm) => {
            if (confirm) {
              this.store.dispatch(
                ImpersonationActions.restartImpersonation.trigger()
              );
            } else {
              this.store.dispatch(
                ImpersonationActions.removeImpersonation.trigger({})
              );
            }
            this.impersonationService.impersonationAlertShown.next(false);
          });
      }
    }
    return next.handle(request);
  }
}
